import React, { useState, useRef, useEffect } from 'react';

const SearchableSelect = ({ value, onChange, options, placeholder = 'Search or select...', name }) => {
  const [query, setQuery]       = useState('');
  const [open, setOpen]         = useState(false);
  const ref                     = useRef(null);

  const filtered = options.filter(o =>
    o.toLowerCase().includes(query.toLowerCase())
  );

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const select = option => {
    onChange({ target: { name, value: option } });
    setQuery('');
    setOpen(false);
  };

  const clear = e => {
    e.stopPropagation();
    onChange({ target: { name, value: '' } });
    setQuery('');
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0.5rem', border: '1px solid var(--border-color)', borderRadius: 4,
          background: 'var(--background-color)', cursor: 'pointer', minHeight: 38,
          color: value ? 'var(--text-color)' : 'var(--text-light)',
        }}
      >
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
          {value || placeholder}
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', flexShrink: 0 }}>
          {value && (
            <span onClick={clear} style={{ fontSize: '0.85rem', color: 'var(--text-light)', padding: '0 0.2rem', lineHeight: 1 }}>✕</span>
          )}
          <span style={{ fontSize: '0.7rem', color: 'var(--text-light)' }}>{open ? '▲' : '▼'}</span>
        </div>
      </div>

      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 200,
          background: 'var(--card-color)', border: '1px solid var(--border-color)',
          borderRadius: 4, boxShadow: '0 4px 12px rgba(0,0,0,0.12)', marginTop: 2,
        }}>
          <div style={{ padding: '0.4rem' }}>
            <input
              autoFocus
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="Type to search..."
              onClick={e => e.stopPropagation()}
              style={{
                width: '100%', padding: '0.4rem 0.5rem', border: '1px solid var(--border-color)',
                borderRadius: 4, background: 'var(--background-color)', color: 'var(--text-color)',
                fontSize: '0.88rem', boxSizing: 'border-box',
              }}
            />
          </div>
          <div style={{ maxHeight: 200, overflowY: 'auto' }}>
            {filtered.length === 0 ? (
              <div style={{ padding: '0.6rem 0.75rem', color: 'var(--text-light)', fontSize: '0.85rem' }}>No results found</div>
            ) : filtered.map(o => (
              <div
                key={o}
                onClick={() => select(o)}
                style={{
                  padding: '0.5rem 0.75rem', cursor: 'pointer', fontSize: '0.88rem',
                  background: value === o ? 'var(--accent-color)' : 'transparent',
                  color: value === o ? 'var(--primary-color)' : 'var(--text-color)',
                  fontWeight: value === o ? 600 : 400,
                }}
                onMouseEnter={e => { if (value !== o) e.target.style.background = 'var(--accent-color)'; }}
                onMouseLeave={e => { if (value !== o) e.target.style.background = 'transparent'; }}
              >
                {o}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
